import {
    setLoaderAction,
    setAuthAction,
    setAgentAction,
    setChatsListAction,
    setChatsListFiltersAction,
    setSelectedChatAction,
    setChatOwnerAction,
    setClosedChatAction,
    updateChatAction,
    addOrUpdateChatAction,
    updateChatSeenAction,
    updateCustomerInfoAction,
    setSelectedChatHistoryAction,
    setLikedAnswerAction,
    setNewChatNotificationAction,
    setChatOwnerButtonAction,
    setCurrentChatOptionAction,
    setWorkspaceConfigAction,
    setConversationLabelsAction,
    setConversationTagGroups,
    setChatSocketStatusAction,
    setNotificationSocketStatusAction,
    markChatRead,
    markChatUnread,
    setWorkspaceName,
    setChatsLoading,
    setAgentState,
    setNoDeepLinkChatFound,
} from "./Actions";
export default function ActionsHandler(dispatch) {
    return {
        setChatsAreLoading: (isLoading) => {
            dispatch(setChatsLoading(isLoading));
        },
        setLoader: () => {
            const loaderHash = Math.random().toString(36).slice(2);
            dispatch(setLoaderAction(true, loaderHash));
            return loaderHash;
        },
        unsetLoader: (loaderHash) => {
            dispatch(setLoaderAction(false, loaderHash));
        },
        setAuth: (isAuth, agent) => {
            dispatch(setAuthAction(isAuth, agent));
        },
        setAgent: (name) => {
            dispatch(setAgentAction(name));
        },
        setChats: (chats) => {
            dispatch(setChatsListAction(chats));
        },
        setChatsListFilters: (chatsListFilters) => {
            dispatch(setChatsListFiltersAction(chatsListFilters));
        },
        setSelectedChat: (chat) => {
            dispatch(setSelectedChatAction(chat));
        },
        setSelectedChatHistory: (selectedChatHistory) => {
            dispatch(setSelectedChatHistoryAction(selectedChatHistory));
        },
        setChatOwner: (chat, owner) => {
            dispatch(setChatOwnerAction(chat, owner));
        },
        setClosedChat: (chat) => {
            dispatch(setClosedChatAction(chat));
        },
        updateChat: (chat) => {
            dispatch(updateChatAction(chat));
        },
        updateChatSeen: (chat) => {
            dispatch(updateChatSeenAction(chat));
        },
        addOrUpdateChatAction: (chat) => {
            dispatch(addOrUpdateChatAction(chat));
        },
        updateCustomerInfo: (chat, customer) => {
            dispatch(updateCustomerInfoAction(chat, customer));
        },
        setLikedAnswer: (answer) => {
            dispatch(setLikedAnswerAction(answer));
        },
        setNewChatNotification: (newChats) => {
            dispatch(setNewChatNotificationAction(newChats));
        },
        setChatOwnerButton: (clicked) => {
            dispatch(setChatOwnerButtonAction(clicked));
        },
        setCurrentChatOption: (id, selected) => {
            dispatch(setCurrentChatOptionAction(id, selected));
        },
        setWorkspaceConfig: (config) => {
            dispatch(setWorkspaceConfigAction(config));
        },
        setConversationLabels: (conversationLabels) => {
            dispatch(setConversationLabelsAction(conversationLabels));
        },
        setConversationTagGroups: (groups) => {
            dispatch(setConversationTagGroups(groups));
        },
        setChatSocketStatus: (status) => {
            dispatch(setChatSocketStatusAction(status));
        },
        setNotificationSocketStatus: (status) => {
            dispatch(setNotificationSocketStatusAction(status));
        },
        markChatRead: (chat) => {
            dispatch(markChatRead(chat));
        },
        markChatUnread: (chat) => {
            dispatch(markChatUnread(chat));
        },
        setWorkspaceName: (workspaceName) => {
            dispatch(setWorkspaceName(workspaceName));
        },
        setAgentState: (agentState) => {
            dispatch(setAgentState(agentState));
        },
        /**
         *
         * @param {boolean} set
         * @param {number | undefined} chatId
         */
        setNoDeepLinkChatFound: (set, chatId = undefined) => {
            dispatch(setNoDeepLinkChatFound(set, chatId));
        },
    };
}
